import { useEffect, useState } from "react";
import ResumeIcon from "../../assets/icons/resume.svg";
import BiographicalIcon from "../../assets/icons/bio.svg";
import ContactIcon from "../../assets/icons/phone.svg";
import AddressIcon from "../../assets/icons/address.svg";
import WorkIcon from "../../assets/icons/experience.svg";
import EducationIcon from "../../assets/icons/school.svg";
import JobIcon from "../../assets/icons/job.svg";
import PersonalIcon from "../../assets/icons/badge.svg";
import DocIcon from "../../assets/icons/doc.svg";
import CheckIcon from "../../assets/icons/check.svg";
import CloseIcon from "../../assets/icons/close_grey.svg";
import AddWorkIcon from "../../assets/icons/add_box.svg";
import SalaryIcon from "../../assets/icons/account_balance.svg";
import Socialicon from "../../assets/icons/savings.svg";
import MinusIcon from "../../assets/icons/remove.svg";
import CustomDropdown from "../../commonComponents/CustomDropdown";
import CustomFileInput from "../../commonComponents/CustomFileInput";
import CustomTypeAhead from "../../commonComponents/CustomTypeAhead";
import { commonFields, employeeStatus } from "../../constants/people";
import "./AddEmployeeForm.css";
import CustomInput from "../../commonComponents/CustomInput";
import CustomDatePicker from "../../commonComponents/CustomDatePicker";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { peopleActions } from "../../store/PeopleSlice";
import { State } from "country-state-city";
import { Country } from "country-state-city";
import { searchUserDetails } from "../../store/PeopleSlice/thunk";

const AddEmployeeForm = ({
  showOptional,
  isError,
  setUserData,
  userData,
  isEdit,
  onUploadFile,
  setUpdateData,
  setFormCheck,
  formCheck,
  previousExp,
  setPreviousExp,
  isDraft,
}) => {
  const [navSelected, setNavSelected] = useState("");
  const [countrySelected, setCountrySelected] = useState(null);
  const [stateSelected, setStateSelected] = useState(null);
  const [dateOfResignErr, setDateOfResignErr] = useState();
  const [dateOfJoiningErr, setDateOfJoiningErr] = useState();
  const [selectedDirectManger, setSelectedDirectManger] = useState({});
  const [selectedHRBPManger, setSelectedHRBPManger] = useState({});
  const dispatch = useDispatch();
  const locTypeList =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.loc_name,
    ) || [];
  const WorkAreaCodeList =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.location_fin,
    ) || [];
  const genders =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.genders,
    ) || [];
  const maritalStatus =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.maritalStatus,
    ) || [];
  const businessUnit =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.businessUnit,
    ) || [];
  const officeState =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.officeState,
    ) || [];
  const departmentCode =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.departmentCode,
    ) || [];
  const officeCountry =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.officeCountry,
    ) || [];
  // const employeeStatus =
  //   useSelector(
  //     (state) => state?.people?.dropDownListResponse?.data?.employeeStatus
  //   ) || [];
  const jobBand =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.jobBand,
    ) || [];
  const designationNameAndCode =
    useSelector(
      (state) =>
        state?.people?.dropDownListResponse?.data?.designationNameAndCode,
    ) || [];
  const jobLevelAndCode =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.jobLevelAndCode,
    ) || [];
  const employeeSubType =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.employeeSubType,
    ) || [];
  const baseOfficeLocation =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.baseOfficeLocation,
    ) || [];
  const departmentHierarchy =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.departmentHierarchy,
    ) || [];
  const confirmationStatus =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.confirmationStatus,
    ) || [];
  const costCenter =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.costCenter,
    ) || [];
  const officeCity =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.officeCity,
    ) || [];
  const attendanceWeeklyOff =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.attendanceWeeklyOff,
    ) || [];
  const timeZone =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.timeZone,
    ) || [];
  const employeeType =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.employeeType,
    ) || [];
  const jobGrade =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.jobGrade,
    ) || [];
  const businessUnitHeadName =
    useSelector(
      (state) =>
        state?.people?.dropDownListResponse?.data?.businessUnitHeadName,
    ) || [];
  const nationality =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.nationality,
    ) || [];
  const groupCompanyCode =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.groupCompanyCode,
    ) || [];
  const attendanceShift =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.attendanceShift,
    ) || [];
  const attendancePolicy =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.attendancePolicy,
    ) || [];

  const vendorName =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.vendorName,
    ) || [];
  const searchList =
    useSelector((state) => state?.people?.searchList?.user_details) || [];

  const employmentType =
    useSelector(
      (state) => state?.people?.dropDownListResponse?.data?.employmentType,
    ) || [];

  useEffect(() => {
    return () => {
      dispatch(peopleActions.updateEdit(false));
    };
  }, []);

  useEffect(() => {
    if (userData?.user_details?.bill_amazon == null) {
      setUserData({
        ...userData,
        user_details: {
          ...userData.user_details,
          bill_amazon: 0,
        },
      });
    }
  }, [userData?.user_details?.bill_amazon]);

  useEffect(() => {
    if (userData?.user_details?.direct_manager_employee_id?.length >= 3) {
      setTimeout(() => {
        dispatch(
          searchUserDetails({
            id_or_name: userData?.user_details?.direct_manager_employee_id,
            draft: false,
          }),
        );
      }, 500);
    }
  }, [userData?.user_details?.direct_manager_employee_id]);

  useEffect(() => {
    if (userData?.user_details?.hrbp_employee_id?.length >= 3) {
      setTimeout(() => {
        dispatch(
          searchUserDetails({
            id_or_name: userData?.user_details?.hrbp_employee_id,
            draft: false,
          }),
        );
      }, 500);
    }
  }, [userData?.user_details?.hrbp_employee_id]);

  const getCountryDetails = (countryName) => {
    const country = Country.getAllCountries().find(
      (c) => c.name === countryName,
    );
    return country ? { ...country } : { isoCode: "", name: "" };
  };

  const getStateDetails = (countryName, stateName) => {
    const state = State.getStatesOfCountry(countryName.isoCode).find(
      (s) => s.name === stateName,
    );

    return state ? { ...state } : { isoCode: "", name: "" };
  };

  useEffect(() => {
    if (isEdit || isDraft) {
      if (userData?.user_details?.address_country) {
        let country = getCountryDetails(
          userData?.user_details?.address_country,
        );
        setCountrySelected(country?.isoCode);
      }
      if (userData?.user_details?.state) {
        let state = getStateDetails(userData?.user_details?.state);
        setStateSelected(state.isoCode);
      }
    }
  }, [userData, isEdit, isDraft]);

  const updateUserData = (data) => {
    console.log(data, "updated data");

    if (data?.type === "check") {
      setFormCheck(!formCheck);
    }
    if (data?.type === "user") {
      if (
        data?.field === "date_of_exit" ||
        data?.field === "date_of_resignation" ||
        data?.field === "date_of_joining"
      ) {
        // check date of date of joining is greater than or equal to date of resignation and date of exit
        if (data?.field === "date_of_joining") {
          setDateOfJoiningErr(false);
          if (userData?.user_details?.date_of_resignation) {
            const checkIfDateOfJoiningWithDORValid = moment(
              new Date(data?.value),
            ).isAfter(
              moment(new Date(userData?.user_details?.date_of_resignation)),
            );
            if (checkIfDateOfJoiningWithDORValid) {
              setDateOfJoiningErr(true);
              return;
            }
          }
          if (userData?.user_details?.date_of_exit) {
            const checkIfDateOfJoiningWithDOEValid = moment(
              new Date(data?.value),
            ).isAfter(moment(new Date(userData?.user_details?.date_of_exit)));
            if (checkIfDateOfJoiningWithDOEValid) {
              setDateOfJoiningErr(true);
              return;
            }
          }
        }

        // check date of resignation is less than or equal to date of exit if field is date of resignation
        if (
          userData?.user_details?.date_of_exit &&
          data?.field === "date_of_resignation"
        ) {
          // console.log("here2");
          setDateOfResignErr(false);
          const checkIfDateOfResignationValid = moment(
            new Date(data?.value),
          ).isSameOrBefore(
            moment(new Date(userData?.user_details?.date_of_exit)),
          );

          if (!checkIfDateOfResignationValid) {
            setDateOfResignErr(true);
            return;
          }
          if (userData?.user_details?.date_of_joining) {
            setDateOfJoiningErr(false);
            const checkIfDateOfJoiningWithDORValid = moment(
              new Date(userData?.user_details?.date_of_joining),
            ).isAfter(moment(new Date(data?.value)));
            if (checkIfDateOfJoiningWithDORValid) {
              setDateOfJoiningErr(true);
              return;
            }
          }
        }

        // check date of resignation is less than or equal to date of exit if field is date of exit
        if (
          userData?.user_details?.date_of_resignation &&
          data?.field === "date_of_exit"
        ) {
          setDateOfResignErr(false);

          const checkIfDateOfExitValid = moment(
            new Date(data?.value),
          ).isSameOrAfter(
            moment(new Date(userData?.user_details?.date_of_resignation)),
          );
          if (!checkIfDateOfExitValid) {
            setDateOfResignErr(true);
            return;
          }
          if (userData?.user_details?.date_of_joining) {
            setDateOfJoiningErr(false);
            const checkIfDateOfJoiningWithDOEValid = moment(
              new Date(userData?.user_details?.date_of_joining),
            ).isAfter(moment(new Date(data?.value)));
            if (checkIfDateOfJoiningWithDOEValid) {
              setDateOfJoiningErr(true);
              return;
            }
          }
        }
      }
      let formattedUserData = { ...userData }.user_details;
      if (
        (data?.value === "" || data?.value === null) &&
        data?.field !== "date_of_exit" &&
        data?.field !== "date_of_resignation"
      ) {
        delete formattedUserData[data?.field];
      } else {
        formattedUserData[data?.field] = data?.value;
      }
      setUserData({
        ...userData,
        user_details: formattedUserData,
      });
      if (isEdit) {
        setUpdateData({
          key: data?.field,
          value: data?.value,
        });
      }
    }
    if (data?.type === "misc") {
      let formattedUserData = {
        ...userData.user_details,
        misc: { ...userData.user_details.misc },
      };
      formattedUserData.misc[data?.field] = data?.value;
      setUserData({
        ...userData,
        user_details: formattedUserData,
      });
      if (isEdit) {
        setUpdateData({
          key: data?.field,
          value: data?.value,
        });
      }
    }
    if (data?.type === "education") {
      const formattedUserData = [...userData.user_details.education];
      let updatedEducationData = formattedUserData?.map((item, i) => {
        if (data?.field.index === i) {
          return {
            ...item,
            [data?.field.key]: data?.value,
          };
        }
        return item;
      });
      setUserData({
        ...userData,
        user_details: {
          ...userData.user_details,
          education: updatedEducationData,
        },
      });
      if (isEdit) {
        setUpdateData({
          key: "education",
          value: updatedEducationData,
        });
      }
    }
    if (data?.type === "work") {
      const formattedUserData = [...userData.user_details.job_history];
      let updatedWorkData = formattedUserData?.map((item, i) => {
        if (data?.field.index === i) {
          return {
            ...item,
            [data?.field.key]: data?.value,
          };
        }
        return item;
      });
      setUserData({
        ...userData,
        user_details: {
          ...userData.user_details,
          job_history: updatedWorkData,
        },
      });
      if (isEdit) {
        setUpdateData({
          key: "job_history",
          value: updatedWorkData,
        });
      }
    }
    if (data?.type === "bank") {
      let formattedUserData = { ...userData }.bank_details;
      formattedUserData[data?.field] = data?.value;
      setUserData({
        ...userData,
        bank_details: formattedUserData,
      });
      if (isEdit) {
        setUpdateData({
          key: data?.field,
          value: data?.value,
          type: "bank",
        });
      }
    }
    if (data?.type === "doc") {
      let formattedUserData = { ...userData }.doc_details;
      formattedUserData[data?.field] = data?.value;
      setUserData({
        ...userData,
        doc_details: formattedUserData,
      });
      if (data?.value?.name) {
        onUploadFile(data?.field, data?.value);
      }
    }
  };

  const addExtraSections = (type) => {
    if (type === "education") {
      setUserData({
        ...userData,
        user_details: {
          ...userData.user_details,
          education: [
            ...userData?.user_details?.education,
            {
              university_name: null,
              educational_category: null,
              education_degree: null,
              field_of_specualisation: null,
              course_type: null,
              gpa: null,
              start_date: null,
              end_date: null,
            },
          ],
        },
      });
    }
    if (type === "work") {
      setUserData({
        ...userData,
        user_details: {
          ...userData.user_details,
          job_history: [
            ...userData?.user_details?.job_history,
            {
              company_name: null,
              job_title: null,
              job_location: null,
              job_summary: null,
              start_date: null,
              end_date: null,
              current_check: false,
            },
          ],
        },
      });
    }
  };

  const removeExtraSections = (type, index) => {
    let updatedEmployeeDetails = { ...userData };
    const arrayTypeToUpdate =
      type === "education"
        ? updatedEmployeeDetails?.user_details?.education
        : updatedEmployeeDetails?.user_details?.job_history;
    const updatedUserArray = arrayTypeToUpdate?.filter(
      (item, i) => i !== index,
    );
    updatedEmployeeDetails.user_details[
      type === "education" ? "education" : "job_history"
    ] = updatedUserArray;
    setUserData(updatedEmployeeDetails);
  };

  const handleSelect = (item, type) => {
    console.log("Selected:", item);
    if (type === "direct") {
      updateUserData({
        value: item?.employee_id,
        field: "direct_manager_employee_id",
        type: "user",
      });
      updateUserData({
        value: item?.full_name,
        field: "direct_manager_name",
        type: "user",
      });
      updateUserData({
        value: item?.company_email_id,
        field: "direct_manager_email",
        type: "user",
      });
    } else if (type === "hrbp") {
      updateUserData({
        value: item?.employee_id,
        field: "hrbp_employee_id",
        type: "user",
      });
      updateUserData({
        value: item?.full_name,
        field: "hrbp_name",
        type: "user",
      });
      updateUserData({
        value: item?.company_email_id,
        field: "hrbp_email_id",
        type: "user",
      });
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex form-nav">
        {!isEdit && (
          <a
            href="#resume"
            className={`flex items-center form-nav-item ${
              navSelected === "resume" ? "active" : ""
            }`}
            onClick={() => setNavSelected("resume")}
          >
            <img src={ResumeIcon} alt="nav-icon" className="nav-icon" />
            <div className="nav-text">Resume</div>
          </a>
        )}
        <a
          href="#bio"
          className={`flex items-center form-nav-item ${
            navSelected === "bio" ? "active" : ""
          }`}
          onClick={() => setNavSelected("bio")}
        >
          <img src={BiographicalIcon} alt="nav-icon" className="nav-icon" />
          <div className="nav-text">Biographical</div>
        </a>
        <a
          href="#contact"
          className={`flex items-center form-nav-item ${
            navSelected === "contact" ? "active" : ""
          }`}
          onClick={() => setNavSelected("contact")}
        >
          <img src={ContactIcon} alt="nav-icon" className="nav-icon" />
          <div className="nav-text">Contact Details</div>
        </a>
        {!isEdit && (
          <a
            href="#address"
            className={`flex items-center form-nav-item ${
              navSelected === "address" ? "active" : ""
            }`}
            onClick={() => setNavSelected("address")}
          >
            <img src={AddressIcon} alt="nav-icon" className="nav-icon" />
            <div className="nav-text">Address Details</div>
          </a>
        )}
        {showOptional && (
          <>
            <a
              href="#edu"
              className={`flex items-center form-nav-item ${
                navSelected === "education" ? "active" : ""
              }`}
              onClick={() => setNavSelected("education")}
            >
              <img src={EducationIcon} alt="nav-icon" className="nav-icon" />
              <div className="nav-text">Education Details</div>
            </a>
            <a
              href="#work"
              className={`flex items-center form-nav-item ${
                navSelected === "work" ? "active" : ""
              }`}
              onClick={() => setNavSelected("work")}
            >
              <img src={WorkIcon} alt="nav-icon" className="nav-icon" />
              <div className="nav-text">Work Experience</div>
            </a>
          </>
        )}
        <a
          href="#job"
          className={`flex items-center form-nav-item ${
            navSelected === "job" ? "active" : ""
          }`}
          onClick={() => setNavSelected("job")}
        >
          <img src={JobIcon} alt="nav-icon" className="nav-icon" />
          <div className="nav-text">Job Details</div>
        </a>
        {!isEdit && (
          <>
            <a
              href="#personal"
              className={`flex items-center form-nav-item ${
                navSelected === "personal" ? "active" : ""
              }`}
              onClick={() => setNavSelected("personal")}
            >
              <img src={PersonalIcon} alt="nav-icon" className="nav-icon" />
              <div className="nav-text">Personal Identity</div>
            </a>
          </>
        )}
        <a
          href="#salary"
          className={`flex items-center form-nav-item ${
            navSelected === "salary" ? "active" : ""
          }`}
          onClick={() => setNavSelected("salary")}
        >
          <img src={SalaryIcon} alt="nav-icon" className="nav-icon" />
          <div className="nav-text">Salary Account Details</div>
        </a>
        <a
          href="#social"
          className={`flex items-center form-nav-item ${
            navSelected === "social" ? "active" : ""
          }`}
          onClick={() => setNavSelected("social")}
        >
          <img src={Socialicon} alt="nav-icon" className="nav-icon" />
          <div className="nav-text">social security</div>
        </a>
        {!isEdit && (
          <>
            <a
              href="#doc"
              className={`flex items-center form-nav-item ${
                navSelected === "doc" ? "active" : ""
              }`}
              onClick={() => setNavSelected("doc")}
            >
              <img src={DocIcon} alt="nav-icon" className="nav-icon" />
              <div className="nav-text">Documents</div>
            </a>
          </>
        )}
      </div>
      <div className="form-contents flex flex-col">
        {!isEdit && (
          <div className="resume" id="resume">
            <div className="items-baseline flex justify-between">
              <div className="flex items-center resume-head">
                <img className="nav-icon" src={ResumeIcon} alt="resume-icon" />
                <div className="form-subhead">resume</div>
              </div>
              <div className="flex items-center">
                {/* <div className="completion-text">0% Completed</div> */}
                {/* <img className="comp-icon" src={ProgessIcon} alt="comp-icon" /> */}
              </div>
            </div>
            <CustomFileInput
              isError={isError}
              showOptional={showOptional}
              isRequired={commonFields?.doc_details?.resume?.required}
              placeholder={"Upload Resume"}
              fileName={userData?.doc_details?.resume}
              updateUserData={updateUserData}
              field={"resume"}
              type={"doc"}
            />
          </div>
        )}
        <div className="biography" id="bio">
          <div className="items-baseline flex justify-between">
            <div className="flex items-center resume-head">
              <img
                className="nav-icon"
                src={BiographicalIcon}
                alt="resume-icon"
              />
              <div className="form-subhead">biographical</div>
            </div>
          </div>
          <div className="flex flex-wrap">
            <CustomInput
              isError={isError}
              label={"First Name"}
              editable={!isEdit}
              value={userData?.user_details?.first_name}
              placeholder="Enter first name"
              onChange={(value) =>
                updateUserData({
                  value: value,
                  field: "first_name",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details.first_name.required}
              preview={showOptional}
              readOnly={isEdit}
              validationStr={commonFields?.user_details.first_name.regex}
            />
            <CustomInput
              isError={isError}
              label={"Middle Name"}
              editable={!isEdit}
              value={userData?.user_details?.middle_name}
              placeholder="Enter middle name"
              onChange={(value) =>
                updateUserData({
                  value: value,
                  field: "middle_name",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details.middle_name.required}
              preview={showOptional}
              readOnly={isEdit}
              validationStr={commonFields?.user_details.middle_name.regex}
            />
            <CustomInput
              isError={isError}
              label={"Last Name"}
              editable={!isEdit}
              value={userData?.user_details?.last_name}
              placeholder="Enter last name"
              onChange={(value) =>
                updateUserData({
                  value: value,
                  field: "last_name",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details.last_name.required}
              preview={showOptional}
              readOnly={isEdit}
              validationStr={commonFields?.user_details.last_name.regex}
            />

            <CustomInput
              isError={isError}
              label={"Fathers Name"}
              editable={true}
              value={userData?.user_details?.fathers_name}
              placeholder="Enter father’s name"
              onChange={(value) =>
                updateUserData({
                  value: value,
                  field: "fathers_name",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details.fathers_name.required}
              preview={showOptional}
              validationStr={commonFields?.user_details.fathers_name.regex}
            />

            <CustomDropdown
              showOptional={showOptional}
              label={"Gender"}
              isError={isError}
              className="emp-form-input"
              options={genders}
              value={userData?.user_details?.gender}
              onSelectOption={(value) => {
                updateUserData({
                  value: value,
                  field: "gender",
                  type: "user",
                });
              }}
              isRequired={commonFields?.user_details?.gender?.required}
            />
            <CustomInput
              isError={isError}
              label={"Blood Group"}
              editable={true}
              value={userData?.user_details?.blood_group}
              placeholder="Enter blood group"
              onChange={(value) =>
                updateUserData({
                  value: value,
                  field: "blood_group",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details.blood_group.required}
              preview={showOptional}
              validationStr={commonFields?.user_details.blood_group.regex}
            />

            <CustomDatePicker
              isRequired={commonFields?.user_details?.date_of_birth?.required}
              showOptional={showOptional}
              isError={isError}
              label={"Date of Birth"}
              value={userData?.user_details?.date_of_birth}
              onChange={(value) => {
                updateUserData({
                  value: value ? moment(value).format("YYYY-MM-DD") : "",
                  field: "date_of_birth",
                  type: "user",
                });
              }}
              placeholderText={"Select a date"}
            />

            <CustomDropdown
              showOptional={showOptional}
              label={"Nationality"}
              isError={isError}
              className="emp-form-input"
              options={nationality}
              value={userData?.user_details?.nationality}
              onSelectOption={(value) =>
                updateUserData({
                  value: value,
                  field: "nationality",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details?.nationality?.required}
            />

            <CustomDropdown
              showOptional={showOptional}
              label={"Marital Status"}
              isError={isError}
              className="emp-form-input"
              options={maritalStatus}
              value={userData?.user_details?.marital_status}
              onSelectOption={(value) =>
                updateUserData({
                  value: value,
                  field: "marital_status",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details?.marital_status?.required}
            />

            <CustomDatePicker
              isRequired={commonFields?.user_details?.anniversary_date.required}
              showOptional={showOptional}
              isError={isError}
              label={"Marriage Anniversary Date"}
              value={userData?.user_details?.anniversary_date || null}
              onChange={(value) =>
                updateUserData({
                  value: value ? moment(value).format("YYYY-MM-DD") : "",
                  field: "anniversary_date",
                  type: "user",
                })
              }
              placeholderText={"Select a date"}
            />
          </div>
        </div>
        <div className="contact" id="contact">
          <div className="items-baseline flex justify-between">
            <div className="flex items-center resume-head">
              <img className="nav-icon" src={ContactIcon} alt="resume-icon" />
              <div className="form-subhead">contact details</div>
            </div>
          </div>
          <div className="flex flex-wrap">
            <div className="flex flex-col">
              <div className="emp-form-label">Personal Mobile Number*</div>
              <div className="flex">
                <input
                  value={"+91"}
                  className="contact-ph-input"
                  readOnly
                  style={{ width: "60px", marginRight: "4px" }}
                />
                <CustomInput
                  isError={isError}
                  editable={true}
                  value={userData?.user_details?.personal_mobile_no}
                  placeholder="Enter personal mobile number"
                  onChange={(value) =>
                    updateUserData({
                      value: value,
                      field: "personal_mobile_no",
                      type: "user",
                    })
                  }
                  isRequired={
                    commonFields?.user_details.personal_mobile_no.required
                  }
                  preview={showOptional}
                  validationStr={
                    commonFields?.user_details.personal_mobile_no.regex
                  }
                  styles={{ width: "320px" }}
                  errorlabel={"personal mobile number"}
                />
              </div>
            </div>
            <div className="flex flex-col">
              <div className="emp-form-label">Company Mobile Number*</div>
              <div className="flex">
                <input
                  value={"+91"}
                  className="contact-ph-input"
                  readOnly
                  style={{ width: "60px", marginRight: "4px" }}
                />
                <CustomInput
                  isError={isError}
                  editable={true}
                  value={userData?.user_details?.office_mobile_no}
                  placeholder="Enter Company Mobile Number"
                  onChange={(value) =>
                    updateUserData({
                      value: value,
                      field: "office_mobile_no",
                      type: "user",
                    })
                  }
                  isRequired={
                    commonFields?.user_details.office_mobile_no.required
                  }
                  preview={showOptional}
                  validationStr={
                    commonFields?.user_details.office_mobile_no.regex
                  }
                  styles={{ width: "320px" }}
                  errorlabel={"Company Mobile Number"}
                />
              </div>
            </div>
            <CustomInput
              isError={isError}
              label={"Personal Email ID"}
              editable={true}
              value={userData?.user_details?.personal_email_id}
              placeholder="Enter Personal Email ID"
              onChange={(value) =>
                updateUserData({
                  value: value,
                  field: "personal_email_id",
                  type: "user",
                })
              }
              isRequired={commonFields?.user_details.personal_email_id.required}
              preview={showOptional}
              validationStr={commonFields?.user_details.personal_email_id.regex}
            />
            {isEdit && (
              <CustomInput
                isError={isError}
                label={"Company Email ID"}
                editable={true}
                value={userData?.user_details?.company_email_id}
                placeholder="Enter Company Email ID"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "company_email_id",
                    type: "user",
                  })
                }
                isRequired={false}
                preview={showOptional}
                validationStr={
                  commonFields?.user_details.company_email_id.regex
                }
              />
            )}
          </div>
        </div>
        {!isEdit && (
          <div className="address" id="address">
            <div className="items-baseline flex justify-between">
              <div className="flex items-center resume-head">
                <img className="nav-icon" src={AddressIcon} alt="resume-icon" />
                <div className="form-subhead">address details</div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <CustomInput
                isError={isError}
                label={"Current Address Line 1"}
                editable={true}
                value={userData?.user_details?.line_1_address}
                placeholder="Enter Line 1 address"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "line_1_address",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.line_1_address.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.line_1_address.regex}
                isTextArea={false}
              />
              <CustomInput
                isError={isError}
                label={"Current Address Line 2"}
                editable={true}
                value={userData?.user_details?.line_2_address}
                placeholder="Enter Line 2 address"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "line_2_address",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.line_2_address.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.line_2_address.regex}
                isTextArea={false}
              />
              <CustomInput
                isError={isError}
                label={"Current Pincode"}
                editable={true}
                value={userData?.user_details?.pincode}
                placeholder="Enter Pincode"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "pincode",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.pincode.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.pincode.regex}
                isTextArea={false}
              />
              <CustomDropdown
                showOptional={showOptional}
                label={"Country"}
                isError={isError}
                className="emp-form-input"
                options={Country.getAllCountries()}
                value={userData?.user_details?.address_country}
                onSelectOption={(value) => {
                  setCountrySelected(value?.isoCode);
                  updateUserData({
                    value: value?.name,
                    field: "address_country",
                    type: "user",
                  });
                }}
                isRequired={
                  commonFields?.user_details?.address_country?.required
                }
                keyName={"name"}
                isObjectDrop={true}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"State"}
                isError={isError}
                className="emp-form-input"
                options={State.getStatesOfCountry(countrySelected)}
                value={userData?.user_details?.state}
                onSelectOption={(value) => {
                  setStateSelected(value?.isoCode);
                  updateUserData({
                    value: value?.name,
                    field: "state",
                    type: "user",
                  });
                }}
                isRequired={commonFields?.user_details?.state?.required}
                disabled={!countrySelected}
                keyName={"name"}
                isObjectDrop={true}
              />

              <CustomInput
                isError={isError}
                label={"City"}
                editable={true}
                value={userData?.user_details?.city}
                placeholder="Enter City"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "city",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.city?.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.city.regex}
                isTextArea={false}
              />
            </div>
          </div>
        )}
        {showOptional && (
          <>
            <div className="education" id="edu">
              <div className="items-baseline flex justify-between">
                <div className="flex items-center resume-head">
                  <img
                    className="nav-icon"
                    src={EducationIcon}
                    alt="resume-icon"
                  />
                  <div className="form-subhead">education details</div>
                </div>
              </div>
              {userData?.user_details?.education &&
                userData?.user_details?.education?.map((item, i) => (
                  <div
                    className={`flex flex-col ${
                      (i > 0 ||
                        userData?.user_details?.education?.length > 1) &&
                      "edu-rep"
                    }`}
                  >
                    <div className="flex w-full">
                      <CustomInput
                        isError={isError}
                        label={"University Name"}
                        editable={true}
                        value={item?.university_name}
                        placeholder="Enter University Name"
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: { index: i, key: "university_name" },
                            type: "education",
                          })
                        }
                        isRequired={
                          commonFields?.user_details?.university_name.required
                        }
                        preview={showOptional}
                        validationStr={
                          commonFields?.user_details?.university_name.regex
                        }
                      />
                      <CustomInput
                        isError={isError}
                        label={"Educational Category"}
                        editable={true}
                        value={item?.educational_category}
                        placeholder="Enter Educational Category"
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: { index: i, key: "educational_category" },
                            type: "education",
                          })
                        }
                        isRequired={
                          commonFields?.user_details?.educational_category
                            .required
                        }
                        preview={showOptional}
                        validationStr={
                          commonFields?.user_details?.educational_category.regex
                        }
                      />
                      <CustomInput
                        isError={isError}
                        label={"Education Degree"}
                        editable={true}
                        value={item?.education_degree}
                        placeholder="Enter Education Degree"
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: { index: i, key: "education_degree" },
                            type: "education",
                          })
                        }
                        isRequired={
                          commonFields?.user_details?.education_degree.required
                        }
                        preview={showOptional}
                        validationStr={
                          commonFields?.user_details?.education_degree.regex
                        }
                      />
                    </div>
                    <div className="flex">
                      <CustomInput
                        isError={isError}
                        label={"Field of Specialisation"}
                        editable={true}
                        value={item?.field_of_specualisation}
                        placeholder="Enter Field of Specialisation"
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: { index: i, key: "field_of_specualisation" },
                            type: "education",
                          })
                        }
                        isRequired={
                          commonFields?.user_details?.field_of_specualisation
                            .required
                        }
                        preview={showOptional}
                        validationStr={
                          commonFields?.user_details?.field_of_specualisation
                            .regex
                        }
                      />
                      <CustomInput
                        isError={isError}
                        label={"Course Type / Degree Type"}
                        editable={true}
                        value={item?.course_type}
                        placeholder="Enter Course Type / Degree Type"
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: { index: i, key: "course_type" },
                            type: "education",
                          })
                        }
                        isRequired={
                          commonFields?.user_details?.course_type.required
                        }
                        preview={showOptional}
                        validationStr={
                          commonFields?.user_details?.course_type.regex
                        }
                      />
                      <CustomInput
                        isError={isError}
                        label={"GPA / Percentage"}
                        editable={true}
                        value={item?.gpa}
                        placeholder="Enter GPA / Percentage"
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: { index: i, key: "gpa" },
                            type: "education",
                          })
                        }
                        isRequired={commonFields?.user_details?.gpa.required}
                        preview={showOptional}
                        validationStr={commonFields?.user_details?.gpa.regex}
                      />
                    </div>
                    <div className="flex">
                      <CustomDatePicker
                        isRequired={
                          commonFields?.user_details?.start_date?.required
                        }
                        showOptional={showOptional}
                        isError={isError}
                        label={"Start Date"}
                        onChange={(value) =>
                          updateUserData({
                            value: value
                              ? moment(value).format("YYYY-MM-DD")
                              : "",
                            field: { index: i, key: "start_date" },
                            type: "education",
                          })
                        }
                        value={item?.start_date}
                        placeholderText={"Select a date"}
                      />
                      <CustomDatePicker
                        isRequired={
                          commonFields?.user_details?.end_date?.required
                        }
                        showOptional={showOptional}
                        isError={isError}
                        label={"End Date"}
                        value={item?.end_date}
                        onChange={(value) =>
                          updateUserData({
                            value: value
                              ? moment(value).format("YYYY-MM-DD")
                              : "",
                            field: { index: i, key: "end_date" },
                            type: "education",
                          })
                        }
                        placeholderText={"Select a date"}
                      />
                    </div>
                    {i !== userData?.user_details?.education?.length - 1 && (
                      <button
                        className="btn rm-extra"
                        onClick={() => removeExtraSections("education", i)}
                      >
                        <img src={MinusIcon} alt="" />
                        <div className="rm-extra-text">Remove Details</div>
                      </button>
                    )}
                  </div>
                ))}
              <div className="flex">
                <div
                  className="flex items-center add-edu-box"
                  onClick={() => addExtraSections("education")}
                >
                  <img
                    className="add-work-ico"
                    src={AddWorkIcon}
                    alt="add-work-ico"
                  />
                  <div className="add-more-label">
                    Add More Education Details
                  </div>
                </div>
                {userData?.user_details?.education?.length > 1 && (
                  <button
                    className="btn rm-extra ml-8"
                    onClick={() =>
                      removeExtraSections(
                        "education",
                        userData?.user_details?.education?.length - 1,
                      )
                    }
                  >
                    <img src={MinusIcon} alt="" />
                    <div className="rm-extra-text">Remove Details</div>
                  </button>
                )}
              </div>
            </div>
            <div className="work" id="work">
              <div className="items-baseline flex justify-between">
                <div className="flex items-center resume-head">
                  <img className="nav-icon" src={WorkIcon} alt="resume-icon" />
                  <div className="form-subhead">work experience</div>
                </div>
              </div>
              <div className="flex flex-col work-check-common">
                <div className="work-label">
                  Do you have previous work experience?
                </div>
                <div className="flex">
                  <div
                    className={`flex items-center work-check-box ${
                      previousExp ? "border-2" : ""
                    }`}
                    onClick={() => {
                      setPreviousExp(true);
                      addExtraSections("work");
                    }}
                  >
                    <img
                      className="work-icon"
                      src={CheckIcon}
                      alt="work-icon"
                    />
                    <div className="work-check-label">Yes</div>
                  </div>
                  <div
                    className={`flex items-center work-check-box ${
                      !previousExp ? "border-2" : ""
                    }`}
                    onClick={() => {
                      setPreviousExp(false);
                      removeExtraSections("work", 0);
                    }}
                  >
                    <img
                      className="work-icon"
                      src={CloseIcon}
                      alt="work-icon"
                    />
                    <div className="work-check-label">No</div>
                  </div>
                </div>
              </div>
              {previousExp &&
                userData?.user_details?.job_history &&
                userData?.user_details?.job_history?.map((item, i) => (
                  <div
                    className={`flex flex-col ${
                      i > 0 &&
                      userData?.user_details?.job_history?.length !== i + 1 &&
                      "job-rep pb-10"
                    }`}
                  >
                    <div className="flex flex-col">
                      <div className="flex w-full">
                        <CustomInput
                          isError={isError}
                          label={"Company Name"}
                          editable={true}
                          value={item?.company_name}
                          placeholder="Enter Company Name"
                          onChange={(value) =>
                            updateUserData({
                              value: value,
                              field: { index: i, key: "company_name" },
                              type: "work",
                            })
                          }
                          isRequired={
                            commonFields?.user_details?.company_name.required
                          }
                          preview={showOptional}
                          validationStr={
                            commonFields?.user_details?.company_name.regex
                          }
                        />

                        <CustomInput
                          isError={isError}
                          label={"Job Title"}
                          editable={true}
                          value={item?.job_title}
                          placeholder="Enter Job Title"
                          onChange={(value) =>
                            updateUserData({
                              value: value,
                              field: { index: i, key: "job_title" },
                              type: "work",
                            })
                          }
                          isRequired={
                            commonFields?.user_details?.job_title.required
                          }
                          preview={showOptional}
                          validationStr={
                            commonFields?.user_details?.job_title.regex
                          }
                        />

                        <CustomInput
                          isError={isError}
                          label={"Job Location"}
                          editable={true}
                          value={item?.job_location}
                          placeholder="Enter Job Location"
                          onChange={(value) =>
                            updateUserData({
                              value: value,
                              field: { index: i, key: "job_location" },
                              type: "work",
                            })
                          }
                          isRequired={
                            commonFields?.user_details?.job_location.required
                          }
                          preview={showOptional}
                          validationStr={
                            commonFields?.user_details?.job_location.regex
                          }
                        />
                      </div>
                      <div className="flex">
                        <CustomDatePicker
                          isRequired={
                            commonFields?.user_details?.start_date.required
                          }
                          showOptional={showOptional}
                          isError={isError}
                          label={"Start Date"}
                          onChange={(value) =>
                            updateUserData({
                              value: value
                                ? moment(value).format("YYYY-MM-DD")
                                : "",
                              field: { index: i, key: "start_date" },
                              type: "work",
                            })
                          }
                          value={item?.start_date}
                          placeholderText={"Select a date"}
                        />
                        <CustomDatePicker
                          isRequired={
                            commonFields?.user_details?.end_date.required
                          }
                          showOptional={showOptional}
                          isError={isError}
                          label={"End Date"}
                          onChange={(value) =>
                            updateUserData({
                              value: value
                                ? moment(value).format("YYYY-MM-DD")
                                : "",
                              field: { index: i, key: "end_date" },
                              type: "work",
                            })
                          }
                          value={item?.end_date}
                          placeholderText={"Select a date"}
                        />
                      </div>
                    </div>
                    <div className="flex form-check-sec">
                      <input
                        type="checkbox"
                        className="form-input-check"
                        onChange={(e) => {
                          updateUserData({
                            value: e.target.checked,
                            field: { index: i, key: "current_check" },
                            type: "work",
                          });
                        }}
                      />
                      <div className="emp-form-label">
                        Currently working here?
                      </div>
                    </div>
                    <div className="mt-10 mb-10 w-full">
                      <CustomInput
                        isError={isError}
                        editable={true}
                        value={item.job_summary}
                        placeholder="write job summary here..."
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: { index: i, key: "job_summary" },
                            type: "work",
                          })
                        }
                        isRequired={
                          commonFields?.user_details?.job_summary.required
                        }
                        preview={showOptional}
                        validationStr={
                          commonFields?.user_details?.job_summary.regex
                        }
                        styles={{ width: "100%" }}
                        isTextArea={true}
                      />
                    </div>
                    {i !== userData?.user_details?.job_history?.length - 1 && (
                      <button
                        className="btn rm-extra"
                        onClick={() => removeExtraSections("work", i)}
                      >
                        <img src={MinusIcon} alt="" />
                        <div className="rm-extra-text">Remove Details</div>
                      </button>
                    )}
                  </div>
                ))}
              {previousExp && (
                <div className="flex">
                  <div
                    className="flex items-center add-work-box"
                    onClick={() => addExtraSections("work")}
                  >
                    <img
                      className="add-work-ico"
                      src={AddWorkIcon}
                      alt="add-work-ico"
                    />
                    <div className="add-more-label">Add More Work Details</div>
                  </div>
                  {userData?.user_details?.job_history?.length > 1 && (
                    <button
                      className="btn rm-extra ml-8"
                      onClick={() =>
                        removeExtraSections(
                          "work",
                          userData?.user_details?.job_history?.length - 1,
                        )
                      }
                    >
                      <img src={MinusIcon} alt="" />
                      <div className="rm-extra-text">Remove Details</div>
                    </button>
                  )}
                </div>
              )}
            </div>
          </>
        )}
        <div className="job" id="job">
          <div className="items-baseline flex justify-between">
            <div className="flex items-center resume-head">
              <img className="nav-icon" src={JobIcon} alt="resume-icon" />
              <div className="form-subhead">job details</div>
            </div>
          </div>
          <div className="job-sec" id="job-sec1">
            <div className="flex flex-wrap">
              <CustomInput
                isError={isError}
                label={"Employee ID"}
                editable={true}
                value={userData?.user_details?.employee_id}
                placeholder="User Employee ID"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "employee_id",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.employee_id.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.employee_id.regex}
                readOnly={true}
              />

              {isEdit && (
                <CustomDropdown
                  showOptional={showOptional}
                  label={"Employee Status"}
                  isError={isError}
                  className="emp-form-input"
                  options={employeeStatus}
                  value={userData?.user_details?.employee_status}
                  isObjectDrop={true}
                  keyName={"value"}
                  previewKey={true}
                  onSelectOption={(value) => {
                    updateUserData({
                      value: value?.value,
                      field: "employee_status",
                      type: "user",
                    });
                  }}
                  isRequired={
                    commonFields?.user_details?.employee_status?.required
                  }
                />
              )}

              <CustomDatePicker
                isRequired={
                  commonFields?.user_details?.date_of_joining.required
                }
                showOptional={showOptional}
                isError={isError}
                label={"Date of Joining"}
                onChange={(value) => {
                  updateUserData({
                    value: value ? moment(value).format("YYYY-MM-DD") : "",
                    field: "date_of_joining",
                    type: "user",
                  });
                  updateUserData({
                    value: value
                      ? moment(value).add(6, "months").format("YYYY-MM-DD")
                      : "",
                    field: "date_of_confirmation",
                    type: "user",
                  });
                }}
                value={userData?.user_details?.date_of_joining}
                placeholderText={"Select a date"}
                dateOfJoiningErr={dateOfJoiningErr}
              />

              <CustomDatePicker
                isRequired={
                  commonFields?.user_details?.date_of_confirmation.required
                }
                showOptional={showOptional}
                isError={isError}
                label={"Date of Confirmation"}
                onChange={(value) =>
                  updateUserData({
                    value: value ? moment(value).format("YYYY-MM-DD") : "",
                    field: "date_of_confirmation",
                    type: "user",
                  })
                }
                value={userData?.user_details?.date_of_confirmation}
                placeholderText={"Select a date"}
                allowFutureDate={true}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Confirmation Status"}
                isError={isError}
                className="emp-form-input"
                options={confirmationStatus}
                value={userData?.user_details?.confirmation_status}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "confirmation_status",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.confirmation_status?.required
                }
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Employee Type"}
                isError={isError}
                className="emp-form-input"
                options={employeeType}
                value={userData?.user_details?.employee_type}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "employee_type",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.employee_type?.required}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Employee Sub-Type"}
                isError={isError}
                className="emp-form-input"
                options={employeeSubType}
                value={userData?.user_details?.employee_sub_type}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "employee_sub_type",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.employee_sub_type?.required
                }
              />
              <CustomDropdown
                showOptional={showOptional}
                label={"Employment Type"}
                isError={isError}
                className="emp-form-input"
                options={employmentType}
                value={userData?.user_details?.employment_type}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "employment_type",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.employment_type?.required
                }
              />
              {isEdit && (
                <CustomDatePicker
                  isRequired={
                    commonFields?.user_details?.date_of_exit?.required
                  }
                  showOptional={showOptional}
                  isError={isError}
                  label={"Date of Exit"}
                  value={userData?.user_details?.date_of_exit}
                  onChange={(value) => {
                    updateUserData({
                      value: value ? moment(value).format("YYYY-MM-DD") : "",
                      field: "date_of_exit",
                      type: "user",
                    });
                  }}
                  placeholderText={"Select a date"}
                  allowFutureDate={true}
                  dateOfResignErr={dateOfResignErr}
                  disabled={true}
                />
              )}
              {isEdit && (
                <CustomDatePicker
                  isRequired={
                    commonFields?.user_details?.date_of_resignation?.required
                  }
                  showOptional={showOptional}
                  isError={isError}
                  label={"Date of Resignation"}
                  value={userData?.user_details?.date_of_resignation}
                  onChange={(value) => {
                    updateUserData({
                      value: value ? moment(value).format("YYYY-MM-DD") : "",
                      field: "date_of_resignation",
                      type: "user",
                    });
                  }}
                  placeholderText={"Select a date"}
                  allowFutureDate={true}
                  dateOfResignErr={dateOfResignErr}
                  disabled={true}
                />
              )}
            </div>
          </div>
          <div className="job-sec" id="job-sec2">
            <div className="flex flex-wrap">
              <CustomDropdown
                showOptional={showOptional}
                label={"Job Band"}
                isError={isError}
                className="emp-form-input"
                options={jobBand}
                value={userData?.user_details?.band}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "band",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.band?.required}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Job Grade"}
                isError={isError}
                className="emp-form-input"
                options={jobGrade}
                value={userData?.user_details?.grade}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "grade",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.grade?.required}
              />

              <CustomInput
                isError={isError}
                label={"Division"}
                editable={true}
                value={userData?.user_details?.division}
                placeholder="Enter Division"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "division",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.division.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.division.regex}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Designation Name & Code"}
                isError={isError}
                className="emp-form-input"
                options={designationNameAndCode}
                value={userData?.user_details?.designation}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "designation",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.designation?.required}
              />

              <CustomInput
                isError={isError}
                label={"Position Name & Code"}
                editable={true}
                value={userData?.user_details?.position_id}
                placeholder="Enter Position Name & Code"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "position_id",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.position_id.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.position_id.regex}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Job Level & Code"}
                isError={isError}
                className="emp-form-input"
                options={jobLevelAndCode}
                value={userData?.user_details?.job_level}
                isObjectDrop={false}
                keyName={"value"}
                previewKey={true}
                onSelectOption={(value) => {
                  updateUserData({
                    value: value,
                    field: "job_level",
                    type: "user",
                  });
                  // updateUserData({
                  //   value: value?.value,
                  //   field: "job_level_code",
                  //   type: "user",
                  // });
                }}
                isRequired={commonFields?.user_details?.job_level?.required}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Business Unit"}
                isError={isError}
                className="emp-form-input"
                options={businessUnit}
                value={userData?.user_details?.business_unit}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "business_unit",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.business_unit.required}
                keyName={"value"}
                isObjectDrop={false}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Business Unit Head Name"}
                isError={isError}
                className="emp-form-input"
                options={businessUnitHeadName}
                value={userData?.user_details?.business_unit_head}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "business_unit_head",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.business_unit_head.required
                }
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Department Code"}
                isError={isError}
                className="emp-form-input"
                options={departmentCode}
                value={userData?.user_details?.department_code}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "department_code",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.department_code.required
                }
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Department Hierarchy"}
                isError={isError}
                className="emp-form-input"
                options={departmentHierarchy}
                value={userData?.user_details?.departments_hierarchy}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "departments_hierarchy",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.departments_hierarchy.required
                }
              />
            </div>
          </div>
          <div className="job-sec" id="job-sec3">
            <div className="flex flex-wrap">
              <CustomDropdown
                showOptional={showOptional}
                label={"Group Company & Code"}
                isError={isError}
                className="emp-form-input"
                options={groupCompanyCode}
                value={userData?.user_details?.group_company_code}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "group_company_code",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.group_company_code.required
                }
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Base Office Location"}
                isError={isError}
                className="emp-form-input"
                options={baseOfficeLocation}
                value={userData?.user_details?.base_office_location}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "base_office_location",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.base_office_location.required
                }
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Location Type"}
                isError={isError}
                className="emp-form-input"
                options={locTypeList}
                value={userData?.user_details?.location_type}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "location_type",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.location_type.required}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Office Country"}
                isError={isError}
                className="emp-form-input"
                options={officeCountry}
                value={userData?.user_details?.office_country}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "office_country",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.office_country.required}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Office State"}
                isError={isError}
                className="emp-form-input"
                options={officeState}
                value={userData?.user_details?.office_state}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "office_state",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.office_state.required}
              />

              <CustomInput
                isError={isError}
                label={"Office Region"}
                editable={true}
                value={userData?.user_details?.office_region}
                placeholder="Enter Office Region"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "office_region",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.office_region.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.office_region.regex}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Office City"}
                isError={isError}
                className="emp-form-input"
                options={officeCity}
                value={userData?.user_details?.office_city}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "office_city",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.office_city.required}
                // validationStr={commonFields?.user_details?.office_city.regex}
              />

              <CustomInput
                isError={isError}
                label={"City Type"}
                editable={true}
                value={userData?.user_details?.city_type}
                placeholder="Enter City Type"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "city_type",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.city_type.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.city_type.regex}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Cost Center"}
                isError={isError}
                className="emp-form-input"
                options={costCenter}
                value={userData?.user_details?.cost_center}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "cost_center",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.cost_center.required}
              />

              <CustomInput
                isError={isError}
                label={"Centre Type"}
                editable={true}
                value={userData?.user_details?.centre_type}
                placeholder="Enter Centre Type"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "centre_type",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.centre_type.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.centre_type.regex}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Work Area Code"}
                isError={isError}
                className="emp-form-input"
                options={WorkAreaCodeList}
                value={userData?.user_details?.work_area_code_x}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "work_area_code_x",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.work_area_code_x.required
                }
              />
            </div>
          </div>
          <div className="job-sec" id="job-sec4">
            <div className="flex flex-wrap">
              {/* <CustomInput
                isError={isError}
                label={"Direct Manager Employee ID"}
                editable={true}
                value={userData?.user_details?.direct_manager_employee_id}
                placeholder="Enter Direct Manager Employee ID"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "direct_manager_employee_id",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.direct_manager_employee_id
                    .required
                }
                preview={showOptional}
                validationStr={
                  commonFields?.user_details?.direct_manager_employee_id.regex
                }
              /> */}

              <CustomTypeAhead
                labelKey="Direct Manager Employee ID*"
                data={searchList}
                onChange={(value) => {
                  updateUserData({
                    value: value,
                    field: "direct_manager_employee_id",
                    type: "user",
                  });
                  if (value.length <= 6) {
                    updateUserData({
                      value: "",
                      field: "direct_manager_name",
                      type: "user",
                    });
                    updateUserData({
                      value: "",
                      field: "direct_manager_email",
                      type: "user",
                    });
                  }
                }}
                onSearch={(value) => {
                  if (value.length <= 3) {
                    updateUserData({
                      value: "",
                      field: "direct_manager_name",
                      type: "user",
                    });
                    updateUserData({
                      value: "",
                      field: "direct_manager_email",
                      type: "user",
                    });
                  }
                }}
                onSelect={(item) => handleSelect(item, "direct")}
                required={
                  commonFields?.user_details?.direct_manager_employee_id
                    .required
                }
                minLength={3}
                isEmployeeSearch={true}
                valueLabelKey="full_name"
                placeholder="Search using employee id or name"
                isError={isError}
                value={userData?.user_details?.direct_manager_employee_id}
              />
              <CustomInput
                isError={isError}
                label={"Direct Manager Name"}
                editable={false}
                value={userData?.user_details?.direct_manager_name}
                placeholder="Direct Manager Name"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "direct_manager_name",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.direct_manager_name.required
                }
                preview={showOptional}
                validationStr={
                  commonFields?.user_details?.direct_manager_name.regex
                }
              />
              <CustomInput
                isError={isError}
                label={"Direct Manager Email"}
                editable={false}
                value={userData?.user_details?.direct_manager_email}
                placeholder="Enter Direct Manager Email"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "direct_manager_email",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.direct_manager_email.required
                }
                preview={showOptional}
                validationStr={
                  commonFields?.user_details?.direct_manager_email.regex
                }
                additionalValText="Please assign a direct manager with a valid company email ID."
              />

              {/* <CustomInput
                isError={isError}
                label={"HRBP Employee ID"}
                editable={true}
                value={userData?.user_details?.hrbp_employee_id}
                placeholder="Enter HRBP Employee ID"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "hrbp_employee_id",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.hrbp_employee_id.required
                }
                preview={showOptional}
                validationStr={
                  commonFields?.user_details?.hrbp_employee_id.regex
                }
              /> */}
              <CustomTypeAhead
                labelKey="HRBP Employee ID*"
                data={searchList}
                onChange={(value) => {
                  updateUserData({
                    value: value,
                    field: "hrbp_employee_id",
                    type: "user",
                  });
                  if (value.length <= 6) {
                    updateUserData({
                      value: "",
                      field: "hrbp_name",
                      type: "user",
                    });
                    updateUserData({
                      value: "",
                      field: "hrbp_email_id",
                      type: "user",
                    });
                  }
                }}
                onSearch={(value) => {
                  if (value.length <= 3) {
                    updateUserData({
                      value: "",
                      field: "hrbp_name",
                      type: "user",
                    });
                    updateUserData({
                      value: "",
                      field: "hrbp_email_id",
                      type: "user",
                    });
                  }
                }}
                onSelect={(item) => handleSelect(item, "hrbp")}
                required={commonFields?.user_details?.hrbp_employee_id.required}
                minLength={3}
                isEmployeeSearch={true}
                valueLabelKey="full_name"
                placeholder="Search using employee id or name"
                isError={isError}
                value={userData?.user_details?.hrbp_employee_id}
              />
              <CustomInput
                isError={isError}
                label={"HRBP Name"}
                editable={false}
                value={userData?.user_details?.hrbp_name}
                placeholder="HRBP Name"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "hrbp_name",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.hrbp_name.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.hrbp_name.regex}
              />
              <CustomInput
                isError={isError}
                label={"HRBP Email ID"}
                editable={false}
                value={userData?.user_details?.hrbp_email_id}
                placeholder="Enter HRBP Email ID"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "hrbp_email_id",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.hrbp_email_id.required}
                preview={showOptional}
                validationStr={commonFields?.user_details?.hrbp_email_id.regex}
                additionalValText="Please assign a hrbp manager with a valid company email ID."
              />
            </div>
          </div>
          <div className="job-sec" id="job-sec5">
            <div className="flex flex-wrap">
              <CustomDropdown
                showOptional={showOptional}
                label={"Time Zone"}
                isError={isError}
                className="emp-form-input"
                options={timeZone}
                value={userData?.user_details?.time_zone}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "time_zone",
                    type: "user",
                  })
                }
                isRequired={commonFields?.user_details?.time_zone.required}
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Attendance Shift"}
                isError={isError}
                className="emp-form-input"
                options={attendanceShift}
                value={userData?.user_details?.attendance_shift}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "attendance_shift",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.attendance_shift.required
                }
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Attendance Policy"}
                isError={isError}
                className="emp-form-input"
                options={attendancePolicy}
                value={userData?.user_details?.attendance_policy}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "attendance_policy",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.attendance_policy.required
                }
              />

              <CustomDropdown
                showOptional={showOptional}
                label={"Attendance Weekly Off"}
                isError={isError}
                className="emp-form-input"
                options={attendanceWeeklyOff}
                value={userData?.user_details?.attendance_weeklyoff}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "attendance_weeklyoff",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.attendance_weeklyoff.required
                }
              />

              {/* <CustomDropdown
                showOptional={showOptional}
                label={"PL Probation Enable"}
                isError={isError}
                className="emp-form-input"
                options={plProbationEnable}
                value={userData?.user_details?.pl_probation_enable}
                onSelectOption={(value) =>
                  updateUserData({
                    value: value,
                    field: "pl_probation_enable",
                    type: "user",
                  })
                }
                isRequired={
                  commonFields?.user_details?.pl_probation_enable.required
                }
              /> */}
            </div>
          </div>

          <div className="job-sec" id="job-sec6">
            <div className="flex flex-wrap">
              {showOptional && (
                <>
                  <CustomInput
                    isError={isError}
                    label={"Contribution Level"}
                    editable={true}
                    value={userData?.user_details?.contribution_level}
                    placeholder="Enter Contribution Level"
                    onChange={(value) =>
                      updateUserData({
                        value: value,
                        field: "contribution_level",
                        type: "user",
                      })
                    }
                    isRequired={
                      commonFields?.user_details?.contribution_level.required
                    }
                    preview={showOptional}
                    validationStr={
                      commonFields?.user_details?.contribution_level.regex
                    }
                  />
                  <CustomInput
                    isError={isError}
                    label={"Functional Area"}
                    editable={true}
                    value={userData?.user_details?.functional_area}
                    placeholder="Enter Functional Area"
                    onChange={(value) =>
                      updateUserData({
                        value: value,
                        field: "functional_area",
                        type: "user",
                      })
                    }
                    isRequired={
                      commonFields?.user_details?.functional_area.required
                    }
                    preview={showOptional}
                    validationStr={
                      commonFields?.user_details?.functional_area.regex
                    }
                  />
                  <CustomInput
                    isError={isError}
                    label={"Functional Area Cost Center & Code"}
                    editable={true}
                    value={userData?.user_details?.functional_area_cost_center}
                    placeholder="Enter Functional Area Cost Center & Code"
                    onChange={(value) =>
                      updateUserData({
                        value: value,
                        field: "functional_area_cost_center",
                        type: "user",
                      })
                    }
                    isRequired={
                      commonFields?.user_details?.functional_area_cost_center
                        .required
                    }
                    preview={showOptional}
                    validationStr={
                      commonFields?.user_details?.functional_area_cost_center
                        .regex
                    }
                  />

                  <CustomDropdown
                    showOptional={showOptional}
                    label={"Vendor Name"}
                    isError={isError}
                    className="emp-form-input"
                    options={vendorName}
                    value={userData?.user_details?.vendor_name}
                    onSelectOption={(value) =>
                      updateUserData({
                        value: value,
                        field: "vendor_name",
                        type: "user",
                      })
                    }
                    isRequired={
                      commonFields?.user_details?.vendor_name.required
                    }
                  />

                  <CustomInput
                    isError={isError}
                    label={"Vendor Employee ID"}
                    editable={true}
                    value={userData?.user_details?.vendor_emp_id}
                    placeholder="Enter Vendor Employee ID"
                    onChange={(value) =>
                      updateUserData({
                        value: value,
                        field: "vendor_emp_id",
                        type: "user",
                      })
                    }
                    isRequired={
                      commonFields?.user_details?.vendor_emp_id.required
                    }
                    preview={showOptional}
                    validationStr={
                      commonFields?.user_details?.vendor_emp_id.regex
                    }
                  />

                  <CustomDropdown
                    showOptional={showOptional}
                    label={"Bill Amazon"}
                    isError={isError}
                    className="emp-form-input"
                    options={[
                      { key: "0%", value: 0 },
                      { key: "10%", value: 10 },
                      { key: "20%", value: 20 },
                      { key: "30%", value: 30 },
                      { key: "40%", value: 40 },
                      { key: "50%", value: 50 },
                      { key: "60%", value: 60 },
                      { key: "70%", value: 70 },
                      { key: "80%", value: 80 },
                      { key: "90%", value: 90 },
                      { key: "100%", value: 100 },
                    ]}
                    value={
                      userData?.user_details?.bill_amazon === "" ||
                      userData?.user_details?.bill_amazon == null
                        ? userData?.user_details?.bill_amazon
                        : Number(userData.user_details.bill_amazon)
                    }
                    placeholder="Select the percentage from range"
                    onSelectOption={(value) =>
                      updateUserData({
                        value: value.value,
                        field: "bill_amazon",
                        type: "user",
                      })
                    }
                    isObjectDrop={true}
                    keyName="value"
                    previewKey={true}
                    isRequired={
                      commonFields?.user_details?.bill_amazon.required
                    }
                  />
                  <CustomDropdown
                    showOptional={showOptional}
                    label={"Workforce Engagement"}
                    isError={isError}
                    className="emp-form-input"
                    options={[
                      { key: "Regulated", value: "Regulated" },
                      { key: "Flex", value: "Flex" },
                      { key: "SSA", value: "SSA" },
                      { key: "SSA-Amazon", value: "SSA-Amazon" },
                    ]}
                    value={userData?.user_details?.workforce_engagement}
                    placeholder="Select the Workforce Engagement"
                    onSelectOption={(value) =>
                      updateUserData({
                        value: value.value,
                        field: "workforce_engagement",
                        type: "user",
                      })
                    }
                    isObjectDrop={true}
                    keyName="value"
                    previewKey={true}
                    isRequired={
                      commonFields?.user_details?.workforce_engagement.required
                    }
                  />
                </>
              )}

              <CustomDropdown
                showOptional={showOptional}
                label={"Channel"}
                isError={isError}
                className="emp-form-input"
                options={[
                  { key: "Amazon", value: "Amazon" },
                  { key: "Amazon Express", value: "Amazon Express" },
                  { key: "More", value: "More" },
                  { key: "Omni", value: "Omni" },
                  { key: "More Cafe", value: "More Cafe" },
                ]}
                value={userData?.user_details?.channel}
                placeholder="Select the channel"
                onSelectOption={(value) =>
                  updateUserData({
                    value: value.value,
                    field: "channel",
                    type: "user",
                  })
                }
                isObjectDrop={true}
                keyName="value"
                previewKey={true}
                isRequired={commonFields?.user_details?.channel?.required}
              />
            </div>
          </div>

          <div className="job-sec" id="job-sec7">
            <div className="flex">
              <CustomInput
                isError={isError}
                label={"Source of job application"}
                editable={true}
                value={userData?.user_details?.misc?.source_of_job_application}
                placeholder="Enter Source of job application"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "source_of_job_application",
                    type: "misc",
                  })
                }
                isRequired={
                  commonFields?.user_details?.source_of_job_application.required
                }
                preview={showOptional}
                validationStr={
                  commonFields?.user_details?.source_of_job_application.regex
                }
              />

              <div className="flex flex-col work-check-common ml-12">
                <div className="work-label">
                  Ever worked for Aditya Birla Retail or More Retail Pvt Ltd?
                </div>
                <div className="flex pb-12">
                  <div
                    className={`flex items-center work-check-box ${
                      userData?.user_details?.misc?.previous_worked_for_more &&
                      "border-2"
                    }`}
                    onClick={() =>
                      updateUserData({
                        value: true,
                        field: "previous_worked_for_more",
                        type: "misc",
                      })
                    }
                  >
                    <img
                      className="work-icon"
                      src={CheckIcon}
                      alt="work-icon"
                    />
                    <div className="work-check-label">Yes</div>
                  </div>
                  <div
                    className={`flex items-center work-check-box ${
                      !userData?.user_details?.misc?.previous_worked_for_more &&
                      "border-2"
                    }`}
                    onClick={() =>
                      updateUserData({
                        value: false,
                        field: "previous_worked_for_more",
                        type: "misc",
                      })
                    }
                  >
                    <img
                      className="work-icon"
                      src={CloseIcon}
                      alt="work-icon"
                    />
                    <div className="work-check-label">No</div>
                  </div>
                </div>
                {userData?.user_details?.misc?.previous_worked_for_more && (
                  <div className="flex flex-col ad-work-detail">
                    <CustomInput
                      isError={isError}
                      label={"Previous Employee Code"}
                      editable={true}
                      value={userData?.user_details?.misc?.previousEmpCode}
                      placeholder="Enter Previous Employee Code"
                      onChange={(value) =>
                        updateUserData({
                          value: value,
                          field: "previousEmpCode",
                          type: "misc",
                        })
                      }
                      isRequired={
                        commonFields?.user_details?.previousEmpCode.required
                      }
                      preview={showOptional}
                      validationStr={
                        commonFields?.user_details?.previousEmpCode.regex
                      }
                      styles={{ width: "367px" }}
                    />
                    <div>
                      <CustomInput
                        isError={isError}
                        label={"Previous Email Address"}
                        editable={true}
                        value={userData?.user_details?.misc?.previousEmailID}
                        placeholder="Enter Previous Email Address"
                        onChange={(value) =>
                          updateUserData({
                            value: value,
                            field: "previousEmailID",
                            type: "misc",
                          })
                        }
                        isRequired={
                          commonFields?.user_details?.previousEmailID.required
                        }
                        preview={showOptional}
                        validationStr={
                          commonFields?.user_details?.previousEmailID.regex
                        }
                        styles={{ width: "367px" }}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="flex flex-col work-check-common ml-12">
                <div className="work-label">
                  Any Family Members working with More Retail Private Limited?*
                </div>
                <div className="flex pb-12">
                  <div
                    className={`flex items-center work-check-box ${
                      userData?.user_details?.misc?.family_in_more
                        ? "border-2"
                        : ""
                    }`}
                    onClick={() =>
                      updateUserData({
                        value: true,
                        field: "family_in_more",
                        type: "misc",
                      })
                    }
                  >
                    <img
                      className="work-icon"
                      src={CheckIcon}
                      alt="work-icon"
                    />
                    <div className="work-check-label">Yes</div>
                  </div>
                  <div
                    className={`flex items-center work-check-box ${
                      !userData?.user_details?.misc?.family_in_more
                        ? "border-2"
                        : ""
                    }`}
                    onClick={() =>
                      updateUserData({
                        value: false,
                        field: "family_in_more",
                        type: "misc",
                      })
                    }
                  >
                    <img
                      className="work-icon"
                      src={CloseIcon}
                      alt="work-icon"
                    />
                    <div className="work-check-label">No</div>
                  </div>
                </div>
                {userData?.user_details?.misc?.family_in_more && (
                  <div>
                    <CustomInput
                      isError={isError}
                      label={
                        " Name, Official Email ID, Phone Number & Relationship Info"
                      }
                      editable={true}
                      value={userData?.user_details?.misc?.more_user_details}
                      placeholder="Write here..."
                      onChange={(value) =>
                        updateUserData({
                          value: value,
                          field: "more_user_details",
                          type: "misc",
                        })
                      }
                      isRequired={
                        commonFields?.user_details?.more_user_details.required
                      }
                      preview={showOptional}
                      validationStr={
                        commonFields?.user_details?.more_user_details.regex
                      }
                      isTextArea={true}
                      styles={{ width: "367px" }}
                      rows={5}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {!isEdit && (
          <>
            <div className="personal" id="personal">
              <div className="items-baseline flex justify-between">
                <div className="flex items-center resume-head">
                  <img
                    className="nav-icon"
                    src={PersonalIcon}
                    alt="resume-icon"
                  />
                  <div className="form-subhead">personal identity</div>
                </div>
              </div>
              <div className="flex flex-wrap">
                <CustomInput
                  isError={isError}
                  label={"Aadhaar Number"}
                  editable={!isEdit}
                  value={userData?.doc_details?.aadhaar_number}
                  placeholder="Enter Aadhaar Number"
                  onChange={(value) =>
                    updateUserData({
                      value: value,
                      field: "aadhaar_number",
                      type: "doc",
                    })
                  }
                  isRequired={
                    commonFields?.doc_details?.aadhaar_number.required
                  }
                  preview={showOptional}
                  validationStr={
                    commonFields?.doc_details?.aadhaar_number.regex
                  }
                />

                <CustomInput
                  isError={isError}
                  label={"PAN Number"}
                  editable={!isEdit}
                  value={userData?.doc_details?.pan_number}
                  placeholder="Enter PAN Number"
                  onChange={(value) =>
                    updateUserData({
                      value: value,
                      field: "pan_number",
                      type: "doc",
                    })
                  }
                  isRequired={commonFields?.doc_details?.pan_number.required}
                  preview={showOptional}
                  validationStr={commonFields?.doc_details?.pan_number.regex}
                />

                <CustomInput
                  isError={isError}
                  label={"Driving License Number"}
                  editable={!isEdit}
                  value={userData?.doc_details?.dl_number}
                  placeholder="Enter Driving License Number"
                  onChange={(value) =>
                    updateUserData({
                      value: value,
                      field: "dl_number",
                      type: "doc",
                    })
                  }
                  isRequired={commonFields?.doc_details?.dl_number.required}
                  preview={showOptional}
                  validationStr={commonFields?.doc_details?.dl_number.regex}
                />
              </div>
            </div>
          </>
        )}
        <div className="salary" id="salary">
          <div className="items-baseline flex justify-between">
            <div className="flex items-center resume-head">
              <img className="nav-icon" src={SalaryIcon} alt="resume-icon" />
              <div className="form-subhead">salary account details</div>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex flex-wrap">
              <CustomInput
                isError={isError}
                label={"Name of Account Holder"}
                editable={true}
                value={userData?.bank_details?.name_account}
                placeholder="Enter Name of Account Holder"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "name_account",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.name_account.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.name_account.regex}
              />

              <CustomInput
                isError={isError}
                label={"Account Number"}
                editable={true}
                value={userData?.bank_details?.account_number}
                placeholder="Enter Account Number"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "account_number",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.account_number.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.account_number.regex}
              />

              <CustomInput
                isError={isError}
                label={"Bank Name"}
                editable={true}
                value={userData?.bank_details?.bank_name}
                placeholder="Enter Bank Name"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "bank_name",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.bank_name.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.bank_name.regex}
              />

              <CustomInput
                isError={isError}
                label={"Bank Branch"}
                editable={true}
                value={userData?.bank_details?.branch_name}
                placeholder="Enter Bank Branch"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "branch_name",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.branch_name.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.branch_name.regex}
              />

              <CustomInput
                isError={isError}
                label={"Swift / IFSC Code"}
                editable={true}
                value={userData?.bank_details?.ifsc_code}
                placeholder="Enter Swift / IFSC Code"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "ifsc_code",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.ifsc_code.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.ifsc_code.regex}
              />

              <CustomInput
                isError={isError}
                label={"Account Type"}
                editable={true}
                value={userData?.bank_details?.account_type}
                placeholder="Enter Account Type"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "account_type",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.account_type.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.account_type.regex}
              />

              <CustomInput
                isError={isError}
                label={"ESIC Number"}
                editable={true}
                value={userData?.bank_details?.esic_number}
                placeholder="Enter the ESIC number"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "esic_number",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.esic_number.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.esic_number.regex}
              />
            </div>
          </div>
        </div>

        <div className="social" id="social">
          <div className="items-baseline flex justify-between">
            <div className="flex items-center resume-head">
              <img className="nav-icon" src={Socialicon} alt="resume-icon" />
              <div className="form-subhead">social security</div>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex flex-wrap">
              <CustomInput
                isError={isError}
                label={
                  "UAN Number (If you have no UAN Number, please input 12 times 1)"
                }
                editable={true}
                value={userData?.bank_details?.uan_number}
                placeholder="Enter 12 digit number"
                onChange={(value) =>
                  updateUserData({
                    value: value,
                    field: "uan_number",
                    type: "bank",
                  })
                }
                isRequired={commonFields.bank_details.uan_number.required}
                preview={showOptional}
                validationStr={commonFields.bank_details.uan_number.regex}
                errorlabel="UAN Number"
              />
              {!isEdit && (
                <>
                  <CustomInput
                    isError={isError}
                    label={
                      "PF Account Number (If Available from previous company)"
                    }
                    editable={true}
                    value={userData?.bank_details?.pf_number}
                    placeholder="Enter a 22-digit alphanumeric code"
                    onChange={(value) =>
                      updateUserData({
                        value: value,
                        field: "pf_number",
                        type: "bank",
                      })
                    }
                    isRequired={commonFields.bank_details.pf_number.required}
                    preview={showOptional}
                    validationStr={commonFields.bank_details.pf_number.regex}
                    errorlabel="PF Account Number"
                  />

                  <CustomDropdown
                    showOptional={showOptional}
                    label={"TDS Applicability"}
                    isError={isError}
                    className="emp-form-input"
                    options={["Yes", "No"]}
                    value={userData?.bank_details?.tds_applicability}
                    onSelectOption={(value) =>
                      updateUserData({
                        value: value,
                        field: "tds_applicability",
                        type: "bank",
                      })
                    }
                    isRequired={
                      commonFields?.bank_details?.tds_applicability.required
                    }
                  />
                </>
              )}
            </div>
          </div>
        </div>

        {!isEdit && (
          <>
            <div className="documents" id="doc">
              <div className="items-baseline flex justify-between">
                <div className="flex items-center resume-head">
                  <img className="nav-icon" src={DocIcon} alt="resume-icon" />
                  <div className="form-subhead">documents</div>
                </div>
              </div>
              <div className="flex">
                <CustomFileInput
                  isError={isError}
                  showOptional={showOptional}
                  isRequired={
                    commonFields?.doc_details?.profile_picture?.required
                  }
                  placeholder={"Profile Picture"}
                  fileName={userData?.doc_details?.profile_picture}
                  updateUserData={updateUserData}
                  field={"profile_picture"}
                  type={"doc"}
                />
                <CustomFileInput
                  isError={isError}
                  showOptional={showOptional}
                  isRequired={
                    commonFields?.doc_details?.aadhaar_front?.required
                  }
                  placeholder={"Aadhaar Card Front"}
                  className="ml-12"
                  fileName={userData?.doc_details?.aadhaar_front}
                  updateUserData={updateUserData}
                  field={"aadhaar_front"}
                  type={"doc"}
                />
                <CustomFileInput
                  isError={isError}
                  showOptional={showOptional}
                  isRequired={commonFields?.doc_details?.aadhaar_back?.required}
                  placeholder={"Aadhaar Card Back"}
                  className="ml-12"
                  fileName={userData?.doc_details?.aadhaar_back}
                  updateUserData={updateUserData}
                  field={"aadhaar_back"}
                  type={"doc"}
                />
              </div>
              <div className="flex mt-3">
                <CustomFileInput
                  isError={isError}
                  showOptional={showOptional}
                  isRequired={
                    commonFields?.doc_details["marksheet_10th"]?.required
                  }
                  placeholder={"10th Marksheet"}
                  fileName={userData?.doc_details?.["marksheet_10th"]}
                  updateUserData={updateUserData}
                  field={"marksheet_10th"}
                  type={"doc"}
                />
                <CustomFileInput
                  isError={isError}
                  showOptional={showOptional}
                  isRequired={
                    commonFields?.doc_details["marksheet_12th"]?.required
                  }
                  placeholder={"12th Marksheet"}
                  className="ml-12"
                  fileName={userData?.doc_details?.["marksheet_12th"]}
                  updateUserData={updateUserData}
                  field={"marksheet_12th"}
                  type={"doc"}
                />
                <CustomFileInput
                  isError={isError}
                  showOptional={showOptional}
                  isRequired={commonFields?.doc_details?.graduation?.required}
                  placeholder={"Graduation & Post-Graduation Mark Sheet"}
                  className="ml-12"
                  fileName={userData?.doc_details?.graduation}
                  updateUserData={updateUserData}
                  field={"graduation"}
                  type={"doc"}
                />
              </div>
              <div className="flex mt-3">
                <CustomFileInput
                  isError={isError}
                  showOptional={showOptional}
                  isRequired={commonFields?.doc_details?.salary_slip?.required}
                  placeholder={"Upload Salary Slips & Bank Copy"}
                  fileName={userData?.doc_details?.salary_slip}
                  field={"salary_slip"}
                  updateUserData={updateUserData}
                  type={"doc"}
                />
              </div>
            </div>
          </>
        )}
        <div className="confirmation">
          <div className="conf-head">confirmation</div>
          <div className="conf-ack flex flex-col">
            <div className="ack-content mb-12">
              I declare that the information provided above is true and accurate
              to the best of my knowledge.
            </div>
            <div className="ack-content">
              If any of the provided information is found to be incorrect or
              manipulated, the company reserves the right to take appropriate
              actions at any time before or during my employment.
            </div>
          </div>
          <div className="flex conf-check-box">
            <input
              type="checkbox"
              className="conf-check"
              onChange={(e) => {
                updateUserData({
                  value: e.target.checked,
                  field: "formCheck",
                  type: "check",
                });
              }}
            />
            <div className="conf-check-text">
              I confirm that I’ve read all the points mentioned above.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddEmployeeForm;
